import { IInvoice } from '../../invoice/interfaces';
import { IUser } from '../../shared/interfaces/user.interface';

export interface IClientCreditMemo {
  id :number;
  updatedBy :number;
  createdBy :number;
  createdAt :Date;
  updatedAt :number;
  deletedAt :number;
  businessAccountId :number;
  label :string;
  creditMemo :number;
  usedAmount :number;
  balanceAmount :number;
  remarks :string;
  status :EClientCreditMemoStatus;
  creditMemoInvoice :ICreditMemoInvoice[];
  paymentLogs ?:ICreditMemoPaymentLog[];
}

export interface IClientCreditMemoEntry {
  creditMemo :IClientCreditMemo;
  creditMemoId :number;
  amount :number;
  applyCreditMemoEntry :boolean;
}

export interface ICreditMemoPaymentLog {
  id :number;
  poId :number;
  paymentAmount :number;
  paymentDate :Date;
  clientPurchaseOrder ?:IInvoice;
  createdAt :Date;
  createdByUser ?:IUser;
  credit_memo ?:IClientCreditMemo[];
  reference_id :number;
  payment_amount :number;
}

export interface ICreditMemoInvoice {
  id :number;
  invoice_id :number;
  amount_credited :number;
  created_by :any;
  invoice ?:IInvoice[];
  user ?:IUser;
  created_at :number;
}

export interface IClientPurchaseOrderDiscount {
  clientPurchaseOrderId ?:number;
  discountCode :EClientPurchaseOrderDiscountCodes;
  discountAmount :number;
  discountPercent :number;
  discountTypeId ?:number;
  discountType ?:string;
  discountable ?:{
    label :string;
  };
}

export interface IClientCreditMemoInvoiceEntry {
  invoiceId :number;
  amount :number;
  isSelected ?:boolean;
}

export enum EClientCreditMemoStatus {
  ACTIVE = 'ACTIVE',
  APPLIED = 'APPLIED',
  DELETED = 'DELETED',
}

export enum EClientPurchaseOrderDiscountCodes {
  STANDARD = 'STANDARD',
  CREDIT_MEMO = 'CREDIT_MEMO',
}
